import {Skeleton, SkeletonCircle, SkeletonText, Stack} from '@chakra-ui/react';

export default function ChakraSkeleton({...props}) {
    return <Skeleton height="10px" {...props} />;
}
